// juste
const dataImpliedWacc = [
  { investor: 'Uber', pct: 0.128 },
  { investor: 'Lyft', pct: 0.121 }
];

export default dataImpliedWacc;